import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {HelperService} from '../../services/helper.service';
import {ApiService} from '../../../api/api.service';
import {RequestInterface} from '../../intefaces/pagination.interface';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DateFormPreviewComponent} from'../../../on-site-training-creator/dialogs/date-form-preview/date-form-preview.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'pending-on-site-trainings',
  templateUrl: './pending-on-site-trainings.component.html',
  styleUrls: ['./pending-on-site-trainings.component.scss']
})

export class PendingOnSiteTrainingsComponent implements OnInit, OnChanges {
  @Input() setSize: any;
  @Input() change: any;
  @Input() items: any;
  @Input() defaultItems: any;
  @Input() preview: boolean;
  @Input() border: boolean = true;

  widget: any;
  waiting = true;
  columns: any[] = [];
  tableItems: any[] = [];
  isMobile: boolean;

  public request: RequestInterface = {
    sort: {
      field: 'id',
      direction: 'DESC'
    },
    pagination: {
      pageNumber: 1,
      pageSize: 50,
      totalElementsCount: 0,
      totalPages: 0
    },
    waitingForData: false
  };

  constructor(private _helper: HelperService,
              private _api: ApiService,
              private _router: Router,
              private _translate: TranslateService,
              private deviceService: DeviceDetectorService,
              public _dialog: MatDialog) {
    this.isMobile = deviceService.isMobile()
  }

  ngOnInit() {
    this.createTable();
    if(!this.preview){
      this.getData();
    }else{
      this.getExampleData();
      this.prepareWidgetData()
      this.waiting = false;
    }
  }

  getData(filter = ''): void {
    this.request.waitingForData = true;
    if(this.preview){
      this.request.pagination.totalElementsCount = 5;
      this.request.pagination.totalPages = 1;
      this.request.waitingForData = false;
    }else{
      this._api.Dashboard.getPendingOnSiteTrainings().subscribe((res) => {
        this.tableItems = res;
        this.waiting = false;
        this.prepareWidgetData()
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.prepareWidgetData();
  }

  prepareWidgetData(){
    if(this.items) {
      this.widget = {
        sizeClass: null !== this.items.size && this.items.size !== undefined ? this.items.size : this.defaultItems.defaultSize,
        backgroundColor: null !== this.items.backgroundColor && this.items.backgroundColor !== undefined ? this.items.backgroundColor : this.defaultItems.defaultBackgroundColor,
        elementsColor: null !== this.items.elementsColor && this.items.elementsColor !== undefined ? this.items.elementsColor : this.defaultItems.defaultElementsColor,
      };
    }
  }

  hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  getExampleData(){

  const tableItems = [];
    tableItems.push(
        {
          name: this._translate.instant('DashboardWidgetPendingOnSiteTrainings.ExampleName1'),
          date: '22.04.2025',
          users : [
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName2'),
              avatarPath: null
            },
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName1'),
              avatarPath: null
            },
          ]
        },
        {
          name: this._translate.instant('DashboardWidgetPendingOnSiteTrainings.ExampleName2'),
          date: '22.04.2025',
          users : [
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName4'),
              avatarPath: null
            },
          ]
        },
        {
          name: this._translate.instant('DashboardWidgetPendingOnSiteTrainings.ExampleName3'),
          date: '22.04.2025',
          users : [
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName5'),
              avatarPath: null
            },
          ]
        },
        {
          name: this._translate.instant('DashboardWidgetPendingOnSiteTrainings.ExampleName4'),
          date: '22.04.2025',
          users : [
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName4'),
              avatarPath: null
            },
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName5'),
              avatarPath: null
            },
          ]
        },
        {
          name: this._translate.instant('DashboardWidgetPendingOnSiteTrainings.ExampleName5'),
          date: '22.04.2025',
          users : [
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName4'),
              avatarPath: null
            },
            {
              userFullName: this._translate.instant('DashboardWidgetExample.UserName5'),
              avatarPath: null
            },
          ]
        },
    );
    this.tableItems = tableItems;
  }

  createTable() {
    this.columns = [
      {
        index: 'name',
        name: '',
        searchable: false,
        sortable: false,
        value: '',
        defaultValue: '',
        visible: true,
        type: 'STRING',
        css: {
          'padding-left': '10px',
          'min-width': '120px',
        },
        class: 'ft-auto',
      },
      {
        index: 'date',
        name: '',
        searchable: false,
        sortable: false,
        value: '',
        defaultValue: '',
        visible: true,
        type: 'STRING',
        css: {
          'padding-left': '10px',
          'min-width': '185px',
        },
        render: (v) => {
          return this.preview ? v.date : (v.startDate ? moment(v.startDate).format('DD.MM.YYYY HH:mm') : '');
        }
      },
      {
        index: 'users',
        name: '',
        searchable: false,
        sortable: false,
        value: '',
        defaultValue: '',
        visible: true,
        type: 'AVATARS',
        css: {
          'padding-left': '10px',
          'min-width': '80px',
        },
        render: () => {
          return '';
        }
      },
      {
        type: 'MENU',
        visible: true,
        items: [
          {
            name: 'Common.Details',
            icon: '<img src="assets/icons/on-site-training-assignment-blue.svg" alt="icon_plus" class="accept-icon">',
            click: (v) => {
              if(!this.preview) {
                this._router.navigateByUrl('/app/on-site-training/'+ v.trainingId +'/dates/' + v.dateId);
              }
            }
          },
        ],
        css: {
          'width': '40px',
          'min-width': '40px'
        }
      },
    ]
  }

  goTo(data){
    if(!this.preview) {
      this._router.navigateByUrl('/app/logs/system');
    }
  }

  detailsPopup(data, type){
    if(!this.preview) {
      this._dialog.open(DateFormPreviewComponent, {
        disableClose: true,
        minWidth: '350px',
        width: '85vh',
        maxWidth: '1122px',
        data: {
          training: {name: data.name},
          date: data,
          isAssigned: type === 'assigned'
        }
      });
    }
  }
}